"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Exception_1 = require("../../Exceptions/Exception");
var NumberUtils_1 = require("../../Utils/NumberUtils");
var ObjUtils_1 = require("../../Utils/ObjUtils");
var StringUtils_1 = require("../../Utils/StringUtils");
var XoneJSONResulset = /** @class */ (function () {
    /**
     *
     */
    function XoneJSONResulset(connection, Sentence, options) {
        this.m_maxRows = 100;
        this.m_keys = [];
        this.isResultset = true;
        this.m_connection = connection;
        this.m_nIterate = -1;
        this.m_sentence = Sentence;
        this.m_options = options;
        this.m_data = [];
        this.m_maxRows = this.m_data.length;
        this.m_keys = [];
        // this.m_parsed=new SqlParser("ROWID");
        // this.m_parsed.ParseSqlString(strCmd)
    }
    XoneJSONResulset.prototype.populate = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.m_connection.fetchDataAsync(this.m_sentence, options || this.m_options)];
                    case 1:
                        result = _a.sent();
                        if (result.hasError == true) {
                            throw new Exception_1.Exception(result.err);
                        }
                        this.m_data = Array.isArray(result.data) ? result.data : [];
                        this.m_maxRows = this.m_data.length;
                        this.m_keys = this.m_maxRows == 0 ? [] : Object.keys(this.m_data[0]);
                        return [2 /*return*/, this];
                }
            });
        });
    };
    XoneJSONResulset.prototype.getBytes = function (fld) {
        return null;
    };
    XoneJSONResulset.prototype.getColumnCount = function () {
        return this.m_maxRows == 0 ? 0 : this.m_keys.length;
    };
    XoneJSONResulset.prototype.getColumnTypes = function () {
        return [1, 2, 3, 4, 5, 6, 7, 8];
    };
    XoneJSONResulset.prototype.getColumnName = function (ordinal) {
        return this.m_maxRows == 0 ? 0 : this.m_keys[ordinal];
    };
    XoneJSONResulset.prototype.getData = function () {
        return this.m_data;
    };
    XoneJSONResulset.prototype.close = function () {
        this.m_nIterate = -1;
        this.m_data = null;
        this.m_maxRows = 0;
    };
    XoneJSONResulset.prototype.resolverField = function (fld) {
        if (typeof fld == "number")
            return this.m_keys[fld];
        return fld;
    };
    XoneJSONResulset.prototype.getValue = function (fld, nType) {
        switch (nType) {
            case 0: // Numero
                return NumberUtils_1.default.SafeToInt(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            case 2:
                return NumberUtils_1.default.SafeToDouble(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            case 3:
                return ObjUtils_1.default.SafeToDate(this.m_data[this.m_nIterate][this.resolverField(fld)]);
            default:
                return StringUtils_1.default.SafeToString(this.m_data[this.m_nIterate][this.resolverField(fld)]);
        }
    };
    XoneJSONResulset.prototype.getString = function (fld) {
        return this.getValue(fld, 1);
    };
    XoneJSONResulset.prototype.getInt = function (fld) {
        return this.getValue(fld, 0);
    };
    XoneJSONResulset.prototype.getDate = function (fld) {
        return this.getValue(fld, 3);
    };
    Object.defineProperty(XoneJSONResulset.prototype, "PageLen", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.m_options) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.length) || -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XoneJSONResulset.prototype, "PageCache", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.m_options) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.cache) || -1;
        },
        enumerable: false,
        configurable: true
    });
    XoneJSONResulset.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // if (this.PageLen > 0) {
                //     if (this.PageCache > 0) {
                //     } else {
                //         await this.populate();
                //     }
                // }
                return [2 /*return*/, ++this.m_nIterate < this.m_maxRows];
            });
        });
    };
    XoneJSONResulset.prototype.EOF = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.m_nIterate >= this.m_maxRows];
            });
        });
    };
    XoneJSONResulset.prototype.moveTo = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, position == this.m_maxRows || (this.m_nIterate = position) == this.m_maxRows];
            });
        });
    };
    return XoneJSONResulset;
}());
exports.default = XoneJSONResulset;

//# sourceMappingURL=XoneJSONResulset.js.map
